module.exports = __webpack_public_path__ + "img/HC3012-193.89acbc07.jpg";